import React from 'react'

const TextElement = ({ data }) => {
  return (
    <div style={{ whiteSpace: "pre-line" }} dangerouslySetInnerHTML={{ __html: data.text }} />
  )
}

export default TextElement